import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProgramListItemActionButton } from 'elements/eventView/atomic/ProgramListItem/ProgramListItemActionButton';
import { saveAs } from 'file-saver';
import { useAnalytics } from 'libs/utils/site/analytics';
import { useContext } from 'react';
import { useLocalStorage } from 'react-use';
import { CtxEventView } from 'session/ctxEventView';
import { apiCreateProgramItemEvent } from 'static/api/directApi';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    programId: string;
    title: string;
    hasEndDate: boolean;
    storyIds?: string[];
}

export const AddToCalendarButton = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);
    const analytics = useAnalytics();

    const isWide = ctxEventView.isWide;

    const SAVED_TO_CALENDAR_KEY =
        'guide_' + ctxEventView.eventData.guideId + '_saved_to_calendar' + props.programId;

    const [savedToCalendar, setSavedToCalendar] = useLocalStorage<boolean>(SAVED_TO_CALENDAR_KEY);

    function shouldShowAddToCalendar() {
        const isEnabled = ctxEventView.eventData?.programSettings?.showAddToCalendar;
        const isTimezoneSet = !!ctxEventView.eventData?.programSettings?.timezone;

        if (!isEnabled || !isTimezoneSet) {
            return false;
        }

        const isValid = props.hasEndDate;

        return isValid;
    }

    function handleAddToCalendar() {
        const isOneStory = props.storyIds?.length === 1;

        if (isOneStory) {
            analytics.track('event_ui.calendar_event.saved', {
                type: 'program',
                storyId: props.storyIds[0],
                title: props.title
            });
        } else {
            analytics.track('event_ui.detail.open_clicked', {
                type: 'program_list',
                storyIdsLength: (props.storyIds?.length ?? 0).toString(),
                title: props.title
            });
        }
        apiCreateProgramItemEvent({
            guideId: ctxEventView.eventData.guideId,
            guideProgramItemId: props.programId,
            timezone: ctxEventView.eventData?.programSettings?.timezone ?? 'UTC'
        }).then((resp) => {
            const data = resp.data as string;
            const blob = new Blob([data], { type: 'text/calendar;charset=utf-8' });
            saveAs(blob, 'calendar.ics');

            setSavedToCalendar(true);
        });
    }

    if (!shouldShowAddToCalendar()) {
        return null;
    }

    return (
        <S_AddToCalendarButton className={props.className}>
            <ProgramListItemActionButton
                isWide={isWide}
                onClick={handleAddToCalendar}
                icon={['far', 'calendar-plus']}
            >
                {savedToCalendar && <S_Checked icon={['far', 'check']} />}
            </ProgramListItemActionButton>
        </S_AddToCalendarButton>
    );
};

const S_AddToCalendarButton = styled.div``;

const S_Checked = styled(FontAwesomeIcon)`
    border-radius: 50%;
    color: #fff;
    background: #64ae62;
    position: absolute;
    right: -5px;
    bottom: -5px;
    width: 10px;
    height: 10px;
    font-size: 5px;
    padding: 5px;
`;
